/**
 * Where finishing a reading sets the seeker down.
 *
 * With the Mystic they were with. That is the whole rule, and it was broken by
 * a default argument: exitReading(reader_name = 'iam') is bound straight to the
 * Finish button, so it was always called with nothing and always took 'iam'.
 * Finish a reading with Elora and you landed on Mystic AIda's doorstep — and
 * since nothing fetches a profile for a reader you were moved to silently, the
 * canvas above the menu was black.
 *
 * 'iam' is the right answer for exactly one action: "Visit Mystic AIda", which
 * asks for it by name.
 */
export function exitDestination(opts) {
  const { current = '', requested = '' } = opts || {};
  const asked = (requested || '').trim();
  if (asked) return asked;
  const here = (current || '').trim();
  return here || 'iam';
}
